angular.
module("dx.webapp.sorting").
constant("DX_STUDENT_SORT_PREDICATE", Object.freeze({
	NAME: "name",
	FIRST_NAME: "firstName",
	LAST_NAME: "lastName",
	EMAIL: "email",
	STUDENT_CODE: "studentCode",
	ANONYMOUS_ID: "anonymousId",
	FINAL_GRADE: "finalGrade",
	CREATED: "created",
	CODE: "code",
}));
